import {
  FunctionsFetchError,
  FunctionsHttpError,
  FunctionsRelayError,
} from '@supabase/supabase-js';
import { getEnvVar } from '@/renderer/util';
import { supabase } from '@/renderer/services/supabase';

export const supabaseUrl =
  getEnvVar('SUPABASE_URL') || 'https://dfqmwjbmmvudxrmuiafv.supabase.co';
export const supabaseAnonKey = getEnvVar('SUPABASE_ANON_KEY') || '';
export const apiKey = getEnvVar('SUPABASE_PUBLISHABLE_API_KEY') || '';

const getFunctionErrorMessage = async (
  error: FunctionsHttpError | FunctionsRelayError | FunctionsFetchError | Error,
  fallbackMessage: string,
) => {
  if (error instanceof FunctionsHttpError) {
    try {
      const payload = await error.context.json();
      return (
        payload?.error || payload?.message || error.message || fallbackMessage
      );
    } catch {
      return error.message || fallbackMessage;
    }
  }

  if (
    error instanceof FunctionsRelayError ||
    error instanceof FunctionsFetchError
  ) {
    return error.message || fallbackMessage;
  }

  return error.message || fallbackMessage;
};

export const triggerEdgeFunction = async <T>(
  functionName: string,
  payload: T,
): Promise<{ data?: any; error?: string | null }> => {
  try {
    const { data, error } = await supabase.functions.invoke(functionName, {
      body: payload as Record<string, unknown>,
    });

    if (error) {
      return {
        data: null,
        error: await getFunctionErrorMessage(error, 'Request failed'),
      };
    }

    return { data, error: null };
  } catch (error) {
    return {
      data: null,
      error: error instanceof Error ? error.message : 'Network error',
    };
  }
};
